<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-md">
            <div class="td-cnt-title">
                <i class="fas fa-tools dialog-icon"></i>
                <span class="te-title">{{title}}</span>
            </div>
            <div class="td-cnt-body itdcr-body">
                <p class="feasibility-label">{{'feasibility.millAnswer' | translate}}</p>
                <p style="width: 100%;" [innerHTML]="feasibilitySourceDescription"></p>
                <div *ngIf="showItdcrHistoryLink" class="modal-link-bottom-right">
                    <div class="cnt-link">
                        <i class="fas fa-caret-right ico-link"></i>
                        <teiasoft-link [text]="'enquiryBook.viewITDCR' | translate"
                            (onClick)="onNavigateToItdcrHistory()"></teiasoft-link>
                    </div>
                </div>
            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.close' | translate"
                    class="mr-5"></teiasoft-button>
                <ng-container *ngIf="!readOnly">
                    <teiasoft-button (click)="onRejectClick()" [type]="'tb-primary'"
                        [text]="'feasibility.rejectItdcrProposal' | translate" class="mr-5"></teiasoft-button>
                    <teiasoft-button (click)="onConfirmClick()" [type]="'tb-primary'"
                        [text]="'feasibility.confirmItdcrProposal'| translate"></teiasoft-button>
                </ng-container>
            </div>
        </div>

    </div>
</div>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="selectedItdcrNo" [showHistory]="true"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>
